
export const calculateManDay = (items: IPayment.IQuotationItem[]): number => {
  let total = 0;
  items.forEach((item) => {
    total += item.manDay;
  });
  return total;
};
export const convertJsonData = (jsonData: string | null) => {
  if (jsonData) {
    const data = JSON.parse(jsonData);
    if (Array.isArray(data)) {
      return data;
    } else {
      return [data];
    }
  } else {
    return [];
  }
};
